// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__Up4iD","errorLogs":"EditorFooter_errorLogs__2qtpA"};